import { ArchivedProjectItem } from './ArchivedProjectItem'
import { type ProjectDomain } from '../../../../../../types/domain/project-domain'
import { forwardRef } from 'react'

type ArchivededProjectsListProps = {
  archivedProjects: ProjectDomain[]
  onArquivedProjectItemClick: (arquivedProject: ProjectDomain) => void
}

export const ArchivededProjectsList = forwardRef(
  (
    { archivedProjects, onArquivedProjectItemClick }: ArchivededProjectsListProps,
    ref: any
  ) => {
    if (archivedProjects.length === 0) {
      return null
    }

    return (
      <div
        ref={ref}
        className="h-[80vh] max-h-[498px] md:min-h-[494px] pr-4 space-y-2 overflow-y-scroll scrollbar"
      >
        {archivedProjects.map((project) => (
          <ArchivedProjectItem
            key={project.id}
            archivedProject={project}
            onUnarquiveProject={() => onArquivedProjectItemClick(project)}
          />
        ))}
      </div>
    )
  }
)

ArchivededProjectsList.displayName = 'ArquivededProjectsList'
